var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { FirestoreService } from 'common-lib';
export class InvalidProfileModalComponent {
    constructor(fire, auth, router) {
        this.fire = fire;
        this.auth = auth;
        this.router = router;
        this.isValidProfile = false;
        this.closeEvent = new EventEmitter();
        this.ignoreClose = true;
    }
    get onShow() {
        document.addEventListener('touchmove', this.handleTouchMove, { passive: false });
        document.body.style.overflow = 'hidden';
        return this.isValidProfile;
    }
    ngOnInit() { }
    ngOnDestroy() {
        document.removeEventListener('touchmove', this.handleTouchMove);
        document.body.style.overflow = '';
    }
    close() {
        this.isValidProfile = false;
        this.setTimestamp();
    }
    submit() {
        this.isValidProfile = false;
        this.router.navigate(['/profile/step1']);
        this.setTimestamp();
    }
    setTimestamp() {
        return __awaiter(this, void 0, void 0, function* () {
            const profile = this.fire.doc('profiles/' + this.auth.auth.currentUser.uid);
            profile.ref.set({
                modalClosedAt: this.fire.timestamp,
            }, { merge: true });
        });
    }
    handleTouchMove(event) {
        event.preventDefault();
    }
}
